import Moment from "react-moment";
import { CheckBox } from "../../Common/Controls/Controls";
import { KTSVG } from "../../../helpers";
import "./ModalAdicionDemanda.css";

const ModalAdicion = ({
  titulo,
  fecha,
  accionEditar,
  AccionVer,
  setShowModalEtapa,
  currentEtapa,
  setCurrentEtapa 
  
}) => {
  const fechaParse = new Date(fecha);
  return (
    <div className="etapas__Item">
      <CheckBox
        color="#5B0434"
        checked={fecha==""?false:true}
        label={
          <div className={`checkbox__EtapaProcesal ${fecha==""&&"checkbox__EtapaProcesalDisable"}`}>
            <h1>{titulo}</h1>
            <h2>
              {fecha == "" ? (
                ""
              ) : (
                <Moment
                  className={`Fecha_AcreditadoDetalle`}
                  locale="es"
                  format="MMM DD, YYYY"
                  date={fechaParse}
                />
              )}
            </h2>
          </div>
        }
      />
      <div className="etapasIcons__container">
        <button type="button" onClick={() => {setCurrentEtapa(currentEtapa);setShowModalEtapa(true,currentEtapa);}}>
          <KTSVG
            path={"/img/Icons/Editar.svg"}
            className={`svg-icon EditarDemanda`}
          />
        </button>
        <button type="button" onClick={() => {setCurrentEtapa(currentEtapa);setShowModalEtapa(true,currentEtapa);}}>
          <KTSVG
            path={"/img/Icons/Ver.svg"}
            className={`svg-icon VerDemanda`}
          />
        </button>
      </div>
    </div>
  );
};

export default ModalAdicion;
